import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/icons/help-blue.png")